import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { WarnConfirmDialog } from '@/components/common';
import ButtonLoading from '@/components/common/ButtonLoading';
import { SubscriptionActive } from '@/resources/icons';
import { useSubscription, useLocale, useTimezone } from '@/hooks';
import { undoCancelSubscription } from '@/modules/subscriptionManager';
import { formatDate } from '@/util';
import { ctaClicked as posthogCtaClicked } from '@/modules/posthog/posthogManager';
import useStyles from './styles';

const ReactivateButton = ({ className }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [renewModalOpen, setRenewModalOpen] = useState(false);

    const locale = useLocale();
    const timezone = useTimezone();
    const { nextRefreshDate } = useSubscription();

    const handleUndoCancelSubscription = async () => {
        setLoading(true);
        await undoCancelSubscription();

        posthogCtaClicked({
            destination: 'Subscription',
            text: 'Continue Subscription',
            location: 'Subscription Card',
            type: 'button',
            url: window.location.href
        });
    };

    const handleClicked = () => {
        setRenewModalOpen(true);
    };

    return (
        <>
            <ButtonLoading
                variant="contained"
                color="primary"
                fullWidth
                className={className}
                loading={loading}
                disableOnLoading
                onClick={handleClicked}
            >
                Continue Subscription
            </ButtonLoading>
            <WarnConfirmDialog
                open={renewModalOpen}
                customIcon={<SubscriptionActive className={classes.icon} />}
                title="Re-enabling auto renew with current billing Information."
                message={`Your subscription will begin auto renewing on ${formatDate(
                    {
                        isoDate: nextRefreshDate,
                        locale,
                        timezone
                    }
                )}.`}
                onCancel={() => {
                    setRenewModalOpen(false);
                }}
                onConfirm={() => {
                    handleUndoCancelSubscription();
                }}
                buttonLoading={loading}
                confirmColor="#357abc"
                confirmText="Renew"
            />
        </>
    );
};

ReactivateButton.propTypes = {
    className: PropTypes.string
};

ReactivateButton.defaultProps = {
    className: undefined
};

export default ReactivateButton;
